import axios, { AxiosPromise, AxiosRequestConfig, AxiosResponse } from 'axios'

import axiosErrorHandler from './axiosErrorHandler'

export default class PostApi {
  static BASE_URL: string

  constructor(api_url:string) {
    PostApi.BASE_URL = api_url.startsWith('https://') ? api_url : `https://${ api_url }`
  }

  static changeApi(url: string): void {
    if (localStorage) {
      localStorage.setItem('newApiUrl', url)
    }
  }

  private static getLocationHostname() {
    return window.location.hostname
  }

  private static getNewApiUrlIfExists() {
    const newApiUrl = localStorage && localStorage.getItem("newApiUrl");

    if (newApiUrl) {
      return newApiUrl
    }
  }

  static getBaseHostnameApi() {
    const newApi = PostApi.getNewApiUrlIfExists()

    if (newApi) {
      return newApi
    }

    const splitHost = PostApi.getLocationHostname().split('.')

    if (splitHost.length === 3) {
      splitHost[ 0 ] = 'api'
      return 'https://' + splitHost.join('.') + '/cabinet'
    } else {
      return this.BASE_URL
    }
  }

  static getApiUrl() {
    const newApi = PostApi.getNewApiUrlIfExists()

    if (newApi) {
      return newApi
    } else {
      return PostApi.getBaseHostnameApi() + '/v1/'
    }
  }

  static getRequestUrl(type:string, method:string): string {
    type = type ? `${ type }/` : ''
    return `${ PostApi.getApiUrl() }${ type }${ method }`
  }

  static async sendRequest<T = any, D = any>(type: string, method: string, body?: D, config?: AxiosRequestConfig): AxiosPromise<T> {
    const requestOptions:AxiosRequestConfig = {
      method: 'POST',
      withCredentials: true,
      url: PostApi.getRequestUrl(type, method),
      data: body ?? {},
      ...config
    }

    const axiosInstance = axios.create(requestOptions)

    axiosInstance.interceptors.response.use(
      (response: AxiosResponse) => response,
      axiosErrorHandler
    )

    return await axiosInstance.request(requestOptions)
  }
}
